export enum CurrencyPurchaseStep {
  purchaseMethod,
  rampInProgress,
  purchaseComplete,
}
